import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FiHome, FiEdit, FiEdit3, FiUser, FiUserPlus, FiLogOut, FiCheck } from 'react-icons/fi'

import { AuthContext } from '../../contexts/auth'

import avatarImg from '../../assets/avatar.png'

import { SideBar } from './styles'

export function Header() {
  const { logOut, user } = useContext(AuthContext)

  //const [dataUser, setDataUser] = useState(null)
  //console.log(dataUser.adm)
  //console.log(user.status)

  // useEffect(() => {
  //   async function loadDataUser() {
  //     const dataUserStorage = localStorage.getItem("@dataUser")

  //     if (dataUserStorage) {
  //       setDataUser(JSON.parse(dataUserStorage))
  //     }
  //   }

  //   loadDataUser()
  // }, [])

  async function handleLogOut() {
    await logOut()
  }

  return (
    <SideBar>
      <div className='background-avatar'>
        {/* <img src={avatarImg} alt="foto do perfil" /> */}
        <img src={user.avatarUrl === null ? avatarImg : avatarImg} alt="foto do perfil" />
      </div>

      {/* <Link to="/dashboard">
        <FiHome size={25} />
        Inicio
      </Link> */}
      <Link to="/questoes" >
        <FiCheck size={25} />
        Questões
      </Link>

      {user.status.adm === true || user.status.collaborator === true ? (
        <Link to="/cadastrar-questao" >
          <FiEdit size={25} />
          Cadastrar Questão
        </Link>
      ) : (
        <></>
      )}

      {user.status.adm === true || user.status.collaborator === true ? (
        <Link to="/cadastrar-questao2" >
          <FiEdit size={25} />
          Cadastrar Questão2
        </Link>
      ) : (
        <></>
      )}

      {user.status.adm === true || user.status.collaborator === true ? (
        <Link to="/cadastrar-categoria">
          <FiEdit3 size={25} />
          Cadastrar Categoria
        </Link>
      ) : (
        <></>
      )}

      {user.status.adm === true ? (
        <Link to="/cadastrar-colaborador">
          <FiUserPlus size={25} />
          Cadastrar Colaborador
        </Link>
      ) : (
        <></>
      )}

      <Link to="/perfil">
        <FiUser size={25} />
        Perfil
      </Link>
      {/* <Link to="/dashboard">
        <FiHome size={25} />
        Inicio
      </Link> */}
      <Link onClick={() => handleLogOut()} >
        <FiLogOut size={25} />
        Sair
      </Link>

    </SideBar>
  )
}